import React from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import "../../Homepage/Welcome/Welcome.css";
import "./MeetingWelcome.css";
import Heading from "../../../utls/Heading";

const MeetingWelcome = () => {
  return (
    <>
      <div
        className="rectangle position-relative"
        style={{
          "--background-image": `url(${"https://blueberrywebsites.azureedge.net/bbt/images/WelcomeRectangle.png"})`,
        }}
      >
        <div className="welcome-section meeting-wel-sec container  mt-3 mb-5 pt-md-4">
          <div className="row">
            <div className="col-md-12">
              <Heading className="mt-5 text-center headings meeting-welcome">
                <span>WELCOME TO</span> Blueberry Travel MEETINGS{" "}
                <span style={{ fontWeight: "bold", color: "black" }}>& </span>{" "}
                EVENTS
              </Heading>
            </div>
            <div className="col-md-12 mt-2">
              <p className="text-center subtext">
                Your Corporate Meetings & Events Experts Across the Globe
              </p>
            </div>

            <div className="col-md-12 d-flex justify-content-center px-md-5">
              <div className="d-flex justify-content-center flex-column">
                <p className="text-center at-bbt px-md-5">
                  At Blueberry Travel, we understand every meeting and event is
                  an opportunity to create lasting impressions. Here's how we
                  encourage{" "}
                  <span style={{ color: "#02619E", fontWeight: "bold" }}>
                    “Meaningful Connections”
                  </span>
                  .
                </p>
                <p className="text-center  firstPmeeting">
                  Whether you're organizing a corporate conference, a
                  team-building retreat, or a grand celebration, we’ve got you
                  covered! We customize our services to meet your specific
                  needs, delivering a seamless and memorable experience. From
                  selecting the perfect venue to coordinating logistics and
                  providing on-site support, we handle all aspects of event
                  planning with precision and creativity. Our vast network of
                  trusted partners allows us to offer a wide range of options,
                  ensuring not only a successful event but also a unique
                  showcase of your brand and objectives.
                </p>
              </div>
            </div>

            <div className="col-md-12">
              <div className="d-flex flex-column justify-content-center">
                <div className="d-flex justify-content-center">
                  <div className="bgimage-blueberry-m d-flex justify-content-center">
                    <p className="meeting-bgtxt p text-center pb-3 bottom-75 mb-5  end-0">
                      Let us take the stress out of your planning and bring your
                      event to life with our global solutions. Choose Blueberry
                      Travel for your next meeting or event and discover the art
                      of exceptional event management.
                    </p>
                  </div>
                </div>

                {/* <div className="d-flex justify-content-center d-md-none d-block">
                                    <div className="bgimage-blueberry-m d-flex justify-content-center">

                                        <p className="meeting-bgtxt p text-center pb-3 bottom-75 mb-5 end-0">We specialize in simplifying every aspect of corporate meetings and events management to drive greater savings, operational efficiencies, and impactful attendee experiences. By partnering with Blueberry Travel, you’ll work alongside a global leader in corporate travel and events, ensuring that your programs achieve meaningful results.
                                        </p>
                                    </div>
                                </div> */}

                <div className="explore-btn d-flex justify-content-center">
                  <a href="/event-webinar">
                    <button className="  bg-transparent fs4 explore-btn fw-bold border-0 outline-0 mt-0">
                      Explore More….
                    </button>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center mt-2">
            <a href="/event-webinar">
              <button className="arrow-btn border-0 shadow">
                {" "}
                <LazyLoadImage
                  src="https://blueberrywebsites.azureedge.net/bbt/icons/Right%20arrow.png"
                  alt="right-arrow"
                  loading="lazy"
                />
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default MeetingWelcome;
